/**
 * Shared constants for Idle Depths.
 */

/**
 * Application metadata.
 */
export const APP_NAME = 'Idle Depths';
export const APP_SUBTITLE = 'Shores of the Abyss';
export const APP_VERSION = '0.0.2';
export const DEVELOPER_NAME = 'FireKnot Studios';

/**
 * Default server configuration.
 */
export const DEFAULT_SERVER_PORT = 3000;
export const DEFAULT_CLIENT_PORT = 5173;

/**
 * API configuration.
 */
export const API_BASE_PATH = '/api';
export const TRPC_ENDPOINT = '/api/trpc';

/**
 * Health check configuration.
 */
export const HEALTH_CHECK_RETRY_COUNT = 3;
export const HEALTH_CHECK_RETRY_DELAY_MS = 1000;

/**
 * Environment-specific API URLs.
 */
export const API_URLS = {
  development: 'http://localhost:8787',
  staging: 'https://api-staging.idledepths.com',
  beta: 'https://api-beta.idledepths.com',
  production: 'https://api.idledepths.com',
} as const;

/**
 * Get the API URL for the current environment.
 *
 * @param environment - The environment name
 * @returns The API URL for the environment
 */
export function getApiUrl(environment: keyof typeof API_URLS = 'development'): string {
  return API_URLS[environment];
}

// Export entitlement and role constants
export * from './entitlements.js';
export * from './roles.js';

// Export character and stats constants
export * from './character.js';
export * from './stats.js';

// Export item system constants
export * from './items.js';

// Export XP system constants
export * from './xp.js';

// Export skills constants
export * from './skills.js';
